module.exports = __webpack_public_path__ + "static/petsure-stats-f4dc5330823d8c515d3dbeba9799c9bd.png";